import React from "react";
import { usePersonPanel } from "@/context/PersonPanelContext";

// PersonLink — renders a person name as a blue link. Clicking opens the global side panel.
// Accepts either `id` OR `name` (falls back to lookup by name).
export function PersonLink({ id, name, prefix = "", children, className = "", testid }) {
  const { openPerson, byId, byName } = usePersonPanel();
  const person = id ? byId[id] : (name ? byName[name.toLowerCase()] : null);
  const label = children || person?.name || name || "";
  const targetId = person?.id || id;

  if (!targetId) {
    // Not found — render as plain text
    return <span className={className}>{prefix}{label}</span>;
  }
  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); openPerson(targetId); }}
      data-testid={testid || `person-link-${targetId}`}
      className={`text-[#2563EB] hover:text-[#1D4ED8] hover:underline transition-colors ${className}`}
    >
      {prefix}{label}
    </button>
  );
}
